import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap"
import ComponentBackButton from "../../../../common/AdminCommonComponents/Buttons/ComponentBackButton/ComponentBackButton"
import DynamicButton from "../../../../common/AdminCommonComponents/Buttons/DynamicButton/DynamicButton"
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable"
import GrayHeading from "../../../../common/AdminCommonComponents/GrayHeading/GrayHeading"
import DynamicDropdown from "../../../../common/AdminCommonComponents/DynamicDropdown/DynamicDropdown"
import GeneralBackButton from "../../../../common/AdminCommonComponents/Buttons/GeneralBackButton/GeneralBackButton"

const PaymentGateways = () => {
  const tableData = [
    { paymentMethod: "Bank Transfer", type: "Manual", status: "Active" },
    { paymentMethod: "Easypaisa/Jazzcash", type: "Digital Wallet", status: "Active" },
    { paymentMethod: "Paypal", type: "Digital Wallet", status: "Active" },
  ]

  const tableCols = [
    {
      name: "Payment Method",
      selector: (row) => row.paymentMethod,
    },
    {
      name: "Type",
      selector: (row) => row.type,
    },
    {
      name: "Status",
      selector: (row) => row.status,
    },
    {
      name: "Actions",
      cell: () => <button style={{ all: "unset" }}>Edit</button>,
      center: "true",
    },
  ]

  const actions = [
    { label: 'Bank Transfer', action: () => console.log('bank transfer') },
    { label: 'Easypaisa/Jazzcash', action: () => console.log('Easypaisa/Jazzcash') },
    { label: 'Paypal', action: () => console.log('Paypal') },
  ]

  const paymentTypeOptions = [
    { label: 'Manual', action: () => console.log('manual') },
    { label: 'Digital Wallet', action: () => console.log('Digital Wallet') },
    { label: 'Card Payment', action: () => console.log('Card Payment') },
  ]

  const statusOptions = [
    { label: 'Active', action: () => console.log('active') },
    { label: 'Inactive', action: () => console.log('Inactive') },
  ]

  return (
    <>
      <div className="shodow rounded mt-3">
        <DynamicDatatable data={tableData} columns={tableCols} type="yellow" />
      </div>

      <div className="bg-white shadow px-4 p-3 mt-3">
        <GeneralBackButton />
        <div className="d-flex justify-content-center">
          <GrayHeading>Add Payment Method</GrayHeading>
        </div>

        <Form className="mt-3" onSubmit={(e) => e.preventDefault()}>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label className="fw-semibold" for="paymentMethod">
                  Payment Method
                </Label>
                <DynamicDropdown placeholder="Select payment method" options={actions} />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label className="fw-semibold" for="paymentType">
                  Payment Type
                </Label>
                <DynamicDropdown placeholder="Select Payment Type" options={paymentTypeOptions} />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label className="fw-semibold" for="apiKey">
                  API Key
                </Label>
                <Input id="apiKey" name="apiKey" placeholder="" type="text" />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label className="fw-semibold" for="status">
                  Status
                </Label>
                <DynamicDropdown placeholder="Active/Inactive" options={statusOptions} />
              </FormGroup>
            </Col>
          </Row>

          <div className="d-flex justify-content-center my-3 gap-3">
            <DynamicButton theme="blue">Save</DynamicButton>
          </div>
        </Form>
      </div>
    </>
  )
}

export default PaymentGateways
